import {
    CUSTOM_ROLE,
    DEFAULT_ROLES,
    RELATIONS,
    USER_RELATIONS
} from '../../app/root/constants'

const fr = {
    dashboard: {
        dashboard: 'Tableau de bord',
        mapView: 'MapView',
        switcherHoverTooltip: 'Définissez et enregistrez votre vue par défaut',
        defaultViewUpdateFail:
            'Échec de la mise à jour de la vue par défaut du tableau de bord',
        reports: 'Rapports des 30 derniers jours',
        addressUpdateSuccess: 'Adresse du lieu mise à jour avec succès',
        addressUpdateFail: 'Échec de la mise à jour de l’adresse du lieu',
        deviceStatusTooltipText: {
            inactive: 'Ces appareils ne sont pas en cours d’utilisation',
            critical: 'Ces appareils nécessitent une inspection',
            info: 'Les appareils fonctionnent normalement',
            warning:
                'Les appareils ont peut-être des problèmes de connectivité ou la batterie est faible'
        },
        loggedInAs: 'Connecté en tant que : '
    },
    customers: {
        customer: 'Client',
        customers: 'Clients',
        plan: 'Plan logiciel',
        noCustomers: 'Aucun client trouvé',
        noCustomer: 'Le client n’a pas été trouvé',
        hotswapPortal: 'Portail HotSwap',
        hotswapPortalAccess: "Autoriser l'accès au processus de Hot Swap",
        hotswapUpdateService: 'Service de mise à jour',
        hotswapUpdateServiceAccess:
            "Autorise l'option de service de mise à jour",
        hotswapWelcomeEmail: 'Email de bienvenue HotSwap',
        customerUsersTable: 'Tableau des utilisateurs du client',
        errorGettingUsersListForCustomer:
            'Échec de l’obtention de la liste des utilisateurs'
    },
    hotSwap: {
        capacityIssueMessage:
            'Chers clients, en raison de la charge de travail actuellement élevée due aux vacances et aux commandes JERRY3, les réservations Hotswap sont libérées chaque jeudi à 15h. Si les réservations Hotswap ne sont actuellement pas possibles, nous vous demandons un peu de patience. Nous mettons à jour les capacités chaque semaine. Si vous avez des questions, vous pouvez contacter directement m.weigert@traplinked.com.',
        hotSwap: 'HotSwap',
        hotSwapAdmin: 'Admin HotSwap',
        hotSwapOrders: 'Commandes HotSwap',
        startHotSwap: 'Démarrer HotSwap',
        hotSwapVideoManual: 'Manuel vidéo HotSwap',
        videoNotSupported:
            'Votre navigateur ne prend pas en charge la balise vidéo.',
        hotSwapType: 'Type de HotSwap',
        swapReplacment: "Remplacement d'Appareil",
        description:
            'Certains de vos appareils peuvent consommer plus de batterie que prévu. Pour résoudre ce problème, nous avons développé un nouveau firmware et les anciens appareils doivent être échangés. Sur cette page, vous pouvez gérer tout le processus.',
        introVideo: 'Vidéo d’introduction',
        welcomeTitle: 'Bienvenue dans notre processus HotSwap',
        welcomeDesc:
            'Nous sommes ravis de vous avoir à bord. Voici quelques astuces pour bien démarrer.',
        summary: {
            changeLocation: 'Changer de lieu'
        },
        hotSwapTableEmptyListMessage:
            "Désolé, il n'y a pas d'articles en échange à afficher pour le moment. Veuillez revenir plus tard ou contacter le support pour obtenir de l'aide.",
        swap_by_user: {
            label: 'Commander des appareils de remplacement',
            title: 'Échangez les appareils par vous-même',
            description:
                'Nous vous envoyons des appareils de remplacement et vous les échangez vous-même',
            features: {
                1: 'Commander des appareils de remplacement',
                2: 'Allumer les nouveaux appareils & éteindre les anciens',
                3: 'Flexible selon vos besoins'
            },
            stepper: {
                firstStepHeader: 'Planification de l’expédition',
                firstStepSubHeader:
                    'Quand devrions-nous expédier les appareils?',
                secondStepHeader: 'Adresse de livraison',
                secondStepSubHeader: 'Où devrions-nous livrer les appareils?',
                thirdStepHeader: 'Résumé',
                thirdStepSubHeader: 'Confirmez votre commande de HotSwap'
            },
            btnText: 'Commander des appareils',
            summary: {
                date: 'Date de livraison',
                address: 'Adresse de livraison'
            },
            successTitle: 'HotSwap programmé avec succès',
            successDesc:
                'Félicitations. Nous commencerons à préparer vos appareils et nous vous les livrerons à temps.',
            footerText: 'Tracking Number:',
            trackingLink: 'Lien de suivi:',
            detailsPageText: 'Shipping',
            termsAndConditonsLinkPart: "J'accepte le HotSwap",
            termsAndConditonsLink: 'Termes et conditions',
            termsAndConditonsTextHeader: 'Conditions de HotSwap',
            termsAndConditonsTextFirstParagraph:
                'Dans le cadre du processus HotSwap, vous acceptez les conditions suivantes :',
            termsAndConditonsTextSecondParagraph:
                "Pour l'échange d'appareils d'entrepôt, veuillez créer un nouvel emplacement dans l'application traplinked et le nommer comme ['Nom de votre entreprise' + Expédition d'entrepôt Hot Swap]. Déplacez tous les appareils LoRa actuellement dans votre entrepôt vers cet emplacement nouvellement créé pour faciliter l'échange fluide des appareils.",
            termsAndConditonsTextThirdParagraph:
                "Pour l'échange des appareils situés sur les sites des clients, nous vous demandons aimablement de vérifier l'attribution dans l'application traplinked. Si vous n'avez pas créé d'emplacements (clients) ou si vous n'utilisez pas notre fonction d'emplacement car vous travaillez uniquement via l'interface traplinked, veuillez nous contacter avant de réserver des appareils de remplacement via ce portail.",
            termsAndConditonsTextFourthParagraph:
                "Dans le cadre du processus HotSwap, vous acceptez de nous retourner les appareils échangés (traplinked GmbH, Zollhof 7, 90443 Nuremberg) dans un délai de 7 jours suivant la réussite du processus HotSwap. Nous prendrons en charge les frais d'expédition, et l'étiquette de retour sera incluse avec vos appareils de remplacement. En cas de retard dans l'expédition de retour dû à vos actions, tout coût supplémentaire encouru pourrait vous être facturé. Nous avons besoin des appareils échangés pour accélérer la révision de tous les systèmes aussi rapidement que possible.",
            termsAndConditonsTextFivethParagraph:
                'Nous sommes disponibles pour vous assister et répondre à toutes vos questions tout au long du processus HotSwap. Merci pour votre coopération et votre compréhension.'
        },
        update_service: {
            label: 'Réserver une date',
            title: 'Service de mise à jour par traplinked',
            description:
                'Nous mettons à jour vos appareils à l’emplacement actuel',
            features: {
                1: 'Prendre un rendez-vous',
                2: 'Mise à jour par un technicien traplinked',
                3: 'Rapide & confortable'
            },
            stepper: {
                firstStepHeader: 'Réserver le service de mise à jour',
                firstStepSubHeader:
                    'Quand le technicien traplinked devrait-il venir?',
                secondStepHeader: 'Adresse du lieu',
                secondStepSubHeader: 'Où est le lieu?',
                thirdStepHeader: 'Résumé',
                thirdStepSubHeader:
                    'Confirmez la réservation du service de mise à jour'
            },
            btnText: 'Prendre un rendez-vous',
            summary: {
                date: 'Date & heure',
                address: 'Adresse du lieu'
            },
            successTitle: 'Service de mise à jour réservé avec succès',
            successDesc:
                'Félicitations. Notre technicien sera à l`endroit défini à la date et à l`heure demandées.',
            footerText: 'Technician:',
            detailsPageText: 'Update Service'
        },
        rememberAddress: 'Se souvenir de l’adresse d’expédition',
        saveAddress: 'Enregistrez cette adresse pour le prochain échange.',
        backToDashboard: 'Retour au tableau de bord',
        accordionDevicesTable: {
            exchangeDevice: "Dispositif d'échange",
            connectivity: 'Connectivité',
            hbInterval: 'Intervalle HB',
            trapSide: 'Côté piège',
            wifiData: 'Données WiFi'
        },
        carrier: 'Transporteur'
    },
    locations: {
        storageSectionTitle: 'Stockage',
        storageSectionNetworkDevicesTitle: 'Dispositifs réseau',
        storageSectionDevicesTitle: 'Dispositifs',
        devicesListTitle: 'Dispositifs',
        dragAndDropMsg: 'Glissez-déposez la broche ici !',
        floorPlanLoadingError:
            'Erreur lors du téléchargement du plan d’étage. Veuillez réessayer',
        locations: 'Emplacements',
        noLocations: 'Aucun emplacement disponible',
        searchUser: 'Rechercher un utilisateur',
        pleaseSelectLocation: 'Veuillez sélectionner un emplacement',
        sureNotToSaveLocation:
            'Êtes-vous sûr de ne pas vouloir enregistrer le nouvel emplacement ?',
        addSubLocation: 'Ajouter une sous-localisation',
        addDevices: 'Ajouter des dispositifs',
        removeLocation: 'Supprimer l’emplacement',
        devices: 'Dispositifs',
        network: 'Réseau',
        networkDevice: 'Dispositif réseau',
        overview: 'Aperçu',
        reports: 'Rapports',
        stats: 'Statistiques',
        shareInfo: 'Accéder aux informations',
        floorPlan: 'Plan d’étage',
        pictures: 'Images',
        location: 'Emplacement',
        organisation: 'Organisation',
        version: 'Version',
        status: 'Statut',
        share: 'Partager',
        batteryStatus: 'État de la batterie',
        actions: 'Actions',
        noDevicesAdded:
            'Aucun nouveau dispositif n’a été ajouté à l’emplacement',
        devicesOnLocation: 'Dispositifs à cet emplacement',
        noDevicesSetupYet:
            'Aucun dispositif n’a encore été configuré sur cet emplacement.',
        nameCanNotBeEmpty: 'Le nom ne peut pas être vide',
        address: 'Adresse',
        parentLocation: 'Emplacement parent',
        noParentLocation: 'Aucun emplacement parent',
        locationNotFound: 'Emplacement non trouvé',
        deviceName: 'Nom du dispositif',
        deviceSerial: 'Numéro de série du dispositif',
        event: 'Événement',
        time: 'Heure',
        reportsOnLocation: 'Rapports sur l’emplacement',
        noReportsOnLocation: 'Aucun rapport à cet emplacement pour le moment',
        locationStatistics: 'Statistiques de l’emplacement',
        noLocationStatistics:
            'Aucune statistique pour cet emplacement pour le moment',
        locationNotShared:
            'Cet emplacement n’est partagé avec aucun autre utilisateur',
        sureRevokeShareAccessLocation:
            'Êtes-vous sûr de vouloir révoquer l’accès de cet utilisateur ?',
        devicesAmount: 'Quantité de dispositifs',
        noDevicesToAddFound: 'Aucun appareil na été trouvé à ajouter.',
        deleteLocationsModalText:
            'Êtes-vous sûr de vouloir supprimer cet emplacement ? Tous les sous-emplacements seront également supprimés. Tous les appareils seront déplacés vers le stockage. Procéder ?',
        dragNDropInfo:
            'Glissez - déposez les fichiers ici ou cliquez pour sélectionner les fichiers.',
        dragNDropFiles:
            '(Vous pouvez télécharger des fichiers png, jpeg et pdf)',
        deleteFloorPlanModal:
            'Êtes-vous sûr de vouloir supprimer le plan d’étage?',
        toDeleteFloorPlanTypeIn:
            'Pour supprimer le plan d’étage, veuillez taper ce numéro: ',
        goToDevice: 'Aller à l’appareil',
        removeFromFloorPlan: 'Retirer du plan d’étage',
        noFloorPlan: 'Il n’y a pas de plan d’étage pour cet emplacement',
        addFloorPlan: 'Télécharger un plan d’étage',
        addDevice: 'Ajouter un appareil',
        addNewDevice: 'Ajouter un nouvel appareil',
        devicesInThisLocation: 'Appareils dans cet emplacement',
        floorPlanBtns: {
            appearance: 'Apparence',
            actions: 'Actions',
            add: 'Ajouter des appareils',
            allFilters: 'Filtres',
            filter: 'Filtrer les appareils',
            delete: 'Supprimer le plan d’étage',
            replace: 'Remplacer le plan',
            serialLabel: 'Les numéros de série',
            nameLabel: "Nom de l'appareil"
        },
        locationsPath: 'Chemin de l’emplacement',
        locationId: "ID de l'emplacement",
        newLocation: '- Nouvel emplacement -',
        responsible: 'Responsable',
        onlyResponsibleLocations: 'Surligner mes emplacements (dans l’arbre) ',
        unlockMarkers: 'Déverrouiller les marqueurs',
        lockMarkers: 'Verrouiller les marqueurs',
        responsibleTooltip:
            'Les emplacements dont vous êtes responsable seront marqués d’un petit point bleu.',
        addResponsible: 'Ajouter un responsable',
        add: 'Ajouter',
        scanWithQr: 'Scanner',
        allLocations: 'Tous',
        myLocations: 'Mes emplacements',
        userSearchError:
            'Une erreur est survenue lors de la recherche d’utilisateurs',
        getResponsiblesError:
            'Une erreur est survenue lors du chargement des responsables de cet emplacement',
        addResponsibleError:
            'Une erreur est survenue lors de la tentative d’ajout d’un responsable',
        deleteResponsibleError:
            'Une erreur est survenue lors de la suppression du responsable',
        getResponsibleLocationsError:
            'Une erreur est survenue lors du chargement des emplacements pour l’utilisateur responsable',
        userNotFound: 'Utilisateur non trouvé..',
        noLocationsForResponsible:
            'Aucun emplacement ne vous a été assigné pour le moment.',
        assign: 'Assigner',
        contact: 'Personne à contacter',
        locationEmail: 'Email de l’emplacement',
        locationDetails: 'Détails de l’emplacement(facultatif)',
        contactPhone: 'Téléphone de l’emplacement',
        noFloorplan: 'Aucun plan d’étage téléchargé pour le moment',
        selectFile: 'Sélectionnez un fichier ou glissez-déposez le fichier ici',
        uploadFloorplan: 'Télécharger un plan d’étage',
        editFloorplan: 'Modifier le plan d’étage',
        crop: 'Recadrer',
        rotate: 'Faire pivoter',
        save: 'Sauvegarder',
        somethingWentWrong: 'Oups, quelque chose s’est mal passé',
        heatmap: 'Heatmap',
        escalationLevels: "Niveaux d'escalade",
        level: 'Niveau',
        sendAutomaticallyTriggered:
            'Envoi automatique de courriers électroniques',
        days: 'Jours',
        hours: 'Heures',
        afterTrapStatus:
            'Après que le piège ait reçu son statut et que le statut n’ait pas changé',
        afterTheTrapTriggered:
            "après que le piège s'est déclenché et que l'état n'a pas changé",
        eMailOfRecipient: 'Courriel du destinataire',
        addLevel: 'Ajouter un niveau',
        escalationModalSubTitle:
            "Le message sera ajouté au courrier électronique avec les informations sur l'appareil et l'image du plan d'étage",
        locationsWithoutAddressLabel:
            'Les lieux suivants n’ont pas d’adresse, veuillez enregistrer l’adresse de ces lieux :',
        locationsWithoutAddressAndWithoutCoordsLabel:
            'Les lieux suivants ont une adresse mais ne peuvent être affichés sur la carte parce que l’adresse n’a pas été trouvée sur la carte, veuillez vérifier l’adresse du lieu',
        floorPlanPinCaution:
            "Nous recommandons de redémarrer l'appareil si vous l'avez déplacé vers un nouvel emplacement",
        showCompletedTasks: 'Afficher les tâches terminées',
        hideCompletedTasks: 'Masquer les tâches terminées',
        tasksAtThisLocation: 'Tâches à cet emplacement',
        createNewTask: 'Créer une nouvelle tâche',
        tasks: 'Tâches',
        tasksFetchFail: 'Échec de la récupération des tâches',
        taskCreated: 'Tâche créée avec succès',
        taskCreateFail: 'Échec de la création de la tâche',
        taskUpdated: 'Tâche mise à jour avec succès',
        taskUpdateFail: 'Échec de la mise à jour de la tâche',
        taskDescriptionTooLong:
            'La description de la tâche est trop longue, un maximum de 1024 caractères est autorisé',
        includeSubLocations: 'Inclure les sous-emplacements',
        last30Days: '30 derniers jours',
        last7Days: '7 derniers jours',
        clickOnThePFM: 'Cliquez sur le point pour plus d’informations',
        reportsAmount: 'Nombre de rapports',
        settingsAndActions: 'Paramètres et actions',
        locationSettings: "Paramètres de l'emplacement",
        locationActions: "Actions de l'emplacement",
        baitSettings: 'Paramètres Jerry Bait',
        successWithAmountOfUpdatedDevices:
            "Succès ! Nombre d'appareils mis à jour :",
        settingsAndActionsAreAppliedToAll:
            "Les paramètres et actions basés sur l'emplacement sont appliqués à tous les appareils de cet emplacement.",
        settingsAndActionsAreNotAppliedToSL:
            'Les paramètres et actions ne sont pas appliqués aux sous-emplacements et aux appareils dans les sous-emplacements.',
        noSettingsConfiguredYet:
            'Aucun paramètre configuré pour cet emplacement.',
        selectSettingType: 'Sélectionnez le type de paramètre',
        areYouSureYouWantToRemoveThisSetting:
            'Êtes-vous sûr de vouloir supprimer ce paramètre ?',
        resetTheActivityThreshold: "Réinitialiser le seuil d'activité",
        resetTheActivityThresholdDescr:
            "La réinitialisation du seuil d'activité efface le nombre d'activités pour la période sélectionnée",
        locationBasedSettingsAndActions:
            "Paramètres et actions basés sur l'emplacement",
        lBasedConfirmReplaceBaitQuestion:
            "En confirmant ceci, vous définirez la date du dernier remplacement d'appât pour tous les appareils de cet emplacement.",
        lBasedConfirmThresholdResetQuestion:
            'En confirmant ceci, vous réinitialiserez les activités pour tous les appareils de cet emplacement. Un nouveau seuil sera défini et les activités seront réinitialisées pour la période sélectionnée.',
        lBasedSettingsAreAppliedYouCanNotEdit:
            'Les valeurs de poids d’appât et d’activité sont définies par l’emplacement. Ouvrez les paramètres de l’emplacement pour les modifier.',
        lBasedSettingsAreApplied:
            'Les valeurs de poids d’appât et d’activité sont définies par l’emplacement.',
        confirmPowerOffDescr:
            "Ceci confirme que vous avez éteint tous les appareils de cet emplacement et définit le statut des appareils sur 'Inactif'.",
        switchMMModeOnDescr:
            "Active le mode maintenance pour tous les appareils de cet emplacement. En mode maintenance, l'appareil ne change pas son statut, les rapports ne sont pas créés et les notifications ne sont pas envoyées.",
        switchMMModeOffDescr:
            'Désactive le mode maintenance pour tous les appareils de cet emplacement.',
        confirmMMModeOnDescr:
            "Le mode maintenance sera activé pour tous les appareils de cet emplacement. En mode maintenance, l'appareil ne change pas son statut, les rapports ne sont pas créés et les notifications ne sont pas envoyées.",
        confirmMMModeOffDescr:
            'Le mode maintenance sera désactivé pour tous les appareils de cet emplacement.'
    },
    devices: {
        noDeviceMoveHistoryMsg:
            'Aucun historique de mouvement pour cet appareil.',
        getDeviceMoveHistoryEx:
            "Une erreur s'est produite lors du chargement de l'historique des mouvements de l'appareil",
        assigned: 'Assigné',
        allDevices: 'Tous les appareils',
        details: 'Détails',
        devices: 'Appareils',
        location: 'Emplacement',
        organisation: 'Organisation',
        version: 'Version',
        serialNr: 'Numéro de série',
        name: 'Nom',
        deviceSerial: "Numéro de série de l'appareil",
        description: 'Description',
        operationModeLabel: 'Mode de fonctionnement',
        heartbeatCount: 'Nombre du heartbeat',
        mode: 'Mode',
        status: 'Statut',
        batteryStatus: 'État de la batterie',
        actions: 'Actions',
        noDevicesSetup: 'Aucun appareil n’a été configuré',
        noUserFromAnotherOrg:
            'Il n’y a pas encore d’utilisateur d’une autre organisation.',
        pleseAddUserFromAnotherOrg:
            'Veuillez ajouter un utilisateur d’une autre organisation.',
        inUserMgmt: 'dans la gestion des utilisateurs',
        chooseUserToShareWith:
            'Veuillez choisir un utilisateur avec qui partager',
        macAddress: 'Adresse MAC',
        battery: 'Batterie',
        deviceIsNotFound: 'Appareil non trouvé',
        nameIsTooShort: 'Le nom est trop court',
        reset: 'Réinitialisation aux paramètres d’usine',
        resetTomStatus: 'Réinitialisation du statut',
        reportCatch: 'Rapport de capture',
        setOffline: 'Confirmer la mise hors tension',
        heartbeatInterval: 'Intervalle du heartbeat',
        occupancyRate: 'Taux d’occupation',
        triggerCount: 'Nombre de déclenchements',
        triggeredSince: 'Déclenché depuis',
        catchCount: 'Nombre de captures',
        traps: 'Pièges',

        noReportsNow: 'Actuellement, il n’y a aucun rapport pour',
        noReportsForRange:
            'Pour cette plage de temps, il n’y a aucun rapport pour',
        noReportsYet: "Il n'y a pas encore de rapport",
        resetDescr:
            'Les statistiques précédentes pour ce dispositif seront supprimées. De plus, les paramètres suivants seront réinitialisés: Nom, Description, Intervalle de battement de coeur. Le dispositif sera réglé sur l’état "Inactif".',
        resetDescrNote:
            'Notez que vous devrez réinitialiser la batterie séparément.',
        reportCatchDescr: 'Êtes - vous sûr(e) de vouloir signaler une capture?',
        reportCatchSelectReport:
            'Pour lequel des rapports suivants voulez-vous créer un rapport d’infestation?',
        setOfflineDescr:
            'Cela confirme que vous avez éteint ce dispositif sur place.Le dispositif est donné l’état "Inactif".',
        resetBatteryDescr:
            'Cela confirme que vous avez remplacé les batteries de ce dispositif sur place.Le compteur de batterie sera réinitialisé à 100%.',
        resetBattery: 'Confirmer le changement de batterie',
        resetTOMStatusDescr:
            'Le statut de ce dispositif TOM sera réinitialisé à "En ligne".',
        online: 'Dispositifs en ligne',
        stock: 'Hors ligne',
        warning: 'Avertissements',
        error: 'Critique',
        filters: {
            warning: 'Avertissements',
            info: 'Dispositifs en ligne',
            inactive: 'Hors ligne',
            critical: 'Critique'
        },
        qrCode: 'Code QR',
        serialEmptyError: 'Dispositif sans numéro de série',
        catchDescription: 'Description de la capture',
        catchDescriptionMessage:
            'Ici, vous pouvez ajouter une description pour la capture',
        wifiSetSuccess: 'Identifiants WiFi définis avec succès',
        wifiSetFail: 'Échec de la configuration des identifiants WiFi',
        wifiSSID: 'SSID WiFi',
        wifiPassword: 'Mot de passe WiFi',
        wifiPasswordMinLengthError: 'Doit être plus long',
        wifiSSIDMinLengthError: 'Ne peut pas être vide',
        wifiSignalStrength: 'Puissance du signal',
        wifiSignalStrengthHover: 'Basé sur le dernier battement de cœur',
        wifiExcellent: 'Très bon',
        wifiGood: 'Bon',
        wifiLow: 'Faible',
        wifiBad: 'Mauvais',
        wifiUnknown: 'Inconnu',
        operationMode: {
            movement: 'Mouvement',
            snaptrap: 'Piège à claques',
            insect: 'Insecte',
            bait: 'Appât'
        },
        operationModeInsect: 'Insecte',
        tom: 'TOM',
        jerry: 'JERRY',
        deviceTypes: {
            tom: 'TOM',
            jerry: 'JERRY',
            'jerry-lora': 'JERRY-LoRa',
            'tm01-1': 'TrapMe',
            trapsensor: 'TrapSensor',
            'jerry-bait-rat': 'JERRY-Bait-Rat'
        },
        deviceOperationMode: 'Mode de fonctionnement',
        deviceType: 'Type de dispositif',
        routerType: 'Type de routeur',
        insectModeTooltip: 'Ce dispositif fonctionne en mode insecte',
        snaptrapModeTooltip: 'Ce dispositif fonctionne en mode piège à souris',
        movementModeTooltip: 'Ce dispositif fonctionne en mode mouvement',
        baitModeTooltip: 'Ce dispositif fonctionne en mode appât',
        rearmed: 'Réarmé',
        inactive: 'Inactif',
        deviceIsInactive: 'Le dispositif est inactif.',
        deviceStatuses: {
            0: 'Inactif',
            1: 'Actif',
            2: 'Manque du heartbeat',
            3: 'Déclenché',
            4: 'Batterie faible',
            5: 'Localisation et connexion',
            6: 'Connexion instable',
            7: 'Légèrement infesté',
            8: 'Lourdement infesté',
            9: 'Déclenchement erroné',
            10: 'Activité (Avertissement)',
            11: 'Activité (Critique)'
        },
        deviceStatusDescription: {
            0: 'Le dispositif est inactif.',
            1: 'Le dispositif est en ligne et fonctionne normalement.',
            2: 'Il semble y avoir des problèmes de connexion : la connexion Wi-Fi à l’emplacement de ce dispositif semble peu fiable.',
            3: 'Un piège à souris a été déclenché et nécessite une inspection manuelle.',
            4: 'Le niveau de la batterie de ce dispositif est faible. Veuillez remplacer les piles.',
            5: 'Le dispositif est en mode balise et peut être localisé.',
            6: 'Il semble y avoir des problèmes de connexion : la connexion Wi-Fi à l’emplacement de ce dispositif semble peu fiable.',
            7: 'Un utilisateur a signalé une légère infestation pour ce dispositif.',
            8: 'Un utilisateur a signalé une infestation importante pour ce dispositif.',
            9: 'Un utilisateur a signalé un déclenchement erroné d’un piège à souris pour ce dispositif.',
            10: 'Un utilisateur a signalé une activité sur ce dispositif.',
            11: 'Un utilisateur a signalé une activité critique sur ce dispositif.'
        },
        deviceStatusShortDescription: {
            0: 'Inactif',
            1: 'Actif',
            2: 'Manque du heartbeat',
            3: 'Déclenché',
            4: 'Batterie faible',
            5: 'Localisation et connexion',
            6: 'Connexion instable',
            7: 'Légèrement infesté',
            8: 'Lourdement infesté',
            9: 'Déclenchement erroné',
            10: 'Activité (Avertissement)',
            11: 'Activité (Critique)'
        },
        deviceLastReportTypeShortDescription: {
            0: 'En ligne', // successfully_set_up
            1: 'En ligne', // restarted
            2: 'Déclenché',
            3: 'En ligne', // rearmed
            '3-bait': 'Appât disponible',
            4: 'Battement manqué',
            5: 'En panne',
            6: 'Localisation et connexion',
            11: 'En ligne', // online_again
            12: 'Inactif',
            13: 'Connexion instable',
            15: 'Légèrement infesté',
            16: 'Lourdement infesté',
            17: 'Déclenchement erroné',
            18: 'Activité (Avertissement)',
            19: 'Activité (Critique)',
            20: 'Capture',
            21: 'Activité détectée',
            22: "Seuil d'activité atteint",
            23: 'Appât faible',
            24: "Seuil d'activité atteint et appât faible",
            25: "Seuil d'activité réinitialisé"
        },
        changeOperationMode:
            'Vous avez choisi un mode différent. Pour appliquer le changement, veuillez éteindre et rallumer votre appareil TOM.',
        pestControlSystemLabel: 'Système de lutte antiparasitaire',
        pestControlSystemNotSelected: 'Non sélectionné',
        pestControlSystems: {
            1: 'AF-Box (Rat)',
            2: 'nagtag (Souris)',
            3: 'nagtag (Rat)',
            4: 'Tunnel Métallique (Rat)',
            5: 'SpeedBreak (Souris)',
            6: 'GSG (Souris)',
            7: 'Support Flexible',
            8: 'Détecteur de Cafards Heisenberg',
            9: 'Piège à Entonnoir à Papillons Agrisense',
            10: "Piège à Mouches UV (n'importe lequel)",
            11: 'GSG (Rat)'
        },
        deviceActions: "Actions de l'appareil",
        serialNumberSearchModal: {
            header: 'Rechercher la liste des numéros de série',
            subHeader:
                'Ici, vous pouvez coller la liste des numéros de série des appareils avec chaque numéro de série sur une nouvelle ligne, comme suit :',
            placeHolder: 'Numéros de série'
        },
        tableConfigurationModal: {
            header: 'Configurer les colonnes du tableau',
            subHeaderMainly: 'Principalement utilisé',
            subHeaderAdditional: 'Supplémentaire'
        },
        moveDevicesModal: {
            header: {
                1: 'Où devrait-il être déplacé ?',
                2: "Déplacer le(s) dispositif(s) vers l'emplacement"
            },
            totalNumber: 'Nombre total :'
        },
        configureTableLabel: 'Configurer la table',
        history: 'Histoire',
        move: 'Déplacer',
        pestControlSystem: 'Système',
        transferMode: 'Mode de transfert',
        cellular: 'Cellulaire',
        connectedGateway: 'Passerelle LoRa',
        gatewayNotFound: 'Passerelle introuvable',
        gatewayLastSignal: 'Dernier signal',
        notAssigned: 'Non assigné',
        moveDToL: 'Déplacer les appareils vers un emplacement',
        youAreNotAbleToMoveTheseDevices:
            "Vous ne pouvez pas déplacer ces appareils car soit les emplacements dans lesquels ils se trouvent ne vous sont pas assignés, soit vous n'avez qu'un accès en lecture pour ceux-ci. Veuillez vérifier votre rôle ou contacter le gestionnaire de votre organisation.",
        devicesAmount: 'Nombre d’appareils',
        noDevicesYouCanMove:
            "Il n'y a pas d'appareils que vous pouvez déplacer vers un autre emplacement parmi ceux que vous avez sélectionnés",
        devicesReadyToMove: 'Ces appareils sont prêts à être déplacés.',
        devicesSelected: 'Sélectionnés',
        moveToLocation: "Déplacer vers l'emplacement",
        delete: 'Supprimer',
        youAreNotAbleToDeleteTheseDevices:
            'Vous ne pouvez pas supprimer ces appareils car soit les emplacements dans lesquels ils se trouvent ne vous sont pas assignés, soit vous ne disposez pas des autorisations de suppression. Veuillez vérifier votre rôle ou contacter le gestionnaire de votre organisation.',
        devicesRemovedFromOrg:
            "Les appareils ont été supprimés de l'organisation avec succès",
        deleteDevicesFromOrg: 'Supprimer les appareils de votre organisation',
        noDevicesYouCanDelete:
            "Il n'y a pas d'appareils que vous pouvez supprimer",
        devicesReadyToDelete: 'Ces appareils sont prêts à être supprimés.',
        areYouSureYouWantToDeleteDevices:
            'Êtes-vous sûr de vouloir supprimer ces appareils ? Les appareils seront supprimés de votre compte et ne seront plus visibles dans la liste des appareils.',
        devicesSwitchedOffSuccessfully:
            'Les appareils ont été éteints avec succès',
        noDevicesYouCanSwitchOff:
            "Il n'y a pas d'appareils pour lesquels vous pouvez confirmer l'extinction",
        devicesReadyToSwitchOff: 'Ces appareils sont prêts à être éteints.',
        areYouSureYouWantToConfirmSwitchOff:
            'Êtes-vous sûr de vouloir confirmer l\'extinction de ces appareils ? Cela confirme que vous avez éteint les appareils sur place. Les appareils recevront le statut "Inactif"',
        devicesSwitchedOnMModeSuccessfully:
            'Le mode maintenance a été activé avec succès',
        noDevicesYouCanSwitchOnMMode:
            "Il n'y a pas d'appareils pour lesquels vous pouvez activer le mode maintenance",
        forTheseDevicesYouCanSwitchOnMMode:
            'Pour ces appareils, vous pouvez activer le mode maintenance.',
        areYouSureYouWantToConfirmSwitchOnMMode:
            'Êtes-vous sûr de vouloir activer le mode maintenance pour ces appareils ? En mode maintenance, les rapports ne sont pas créés et les notifications ne sont pas envoyées.',
        youAreNotAbleToSwitchOffTheseDevices:
            'Vous ne pouvez pas éteindre ces appareils car soit les emplacements dans lesquels ils se trouvent ne vous sont pas assignés, soit vous ne disposez pas des autorisations de mise à jour. Veuillez vérifier votre rôle ou contacter le gestionnaire de votre organisation.',
        youAreNotAbleToSwitchOnMModeTheseDevices:
            'Vous ne pouvez pas activer le mode maintenance pour ces appareils car soit les emplacements dans lesquels ils se trouvent ne vous sont pas assignés, soit vous ne disposez pas des autorisations de mise à jour. Veuillez vérifier votre rôle ou contacter le gestionnaire de votre organisation.',
        areYouSureConfirmReplacementOfBait:
            "Êtes-vous sûr de vouloir confirmer le remplacement de l'appât ?",
        areYouSureYouWantToResetTheActivityThreshold:
            "Êtes-vous sûr de vouloir réinitialiser le seuil d'activité ?",
        baitMonitoring: 'Surveillance des appâts',
        enablesOrDisablesBaitWeightTracking:
            'Active ou désactive la surveillance des appâts',
        activityAlertThreshold: "Seuil d'activité",
        whenTheNotificationAlertShouldBeTriggered:
            "Combien d'activités souhaitez-vous avant de recevoir une notification ?",
        per: 'par',
        hours: 'heures',
        days: 'jours',
        baitType: "Type d'appât",
        whichBaitAreYouUsing: 'Quel appât / poids utilisez-vous ?',
        calibration: "Seuil d'appât",
        notifiedWhenBaitWeightLowerThan:
            "À quel poids la plaque d'appât a-t-elle été calibrée ? Vous recevrez une notification à ce poids résiduel.",
        baitPad: "Plaque d'appât",
        replaceBait: "Confirmer le remplacement de l'appât",
        resetsTheBaitStatusToAvailable:
            "Définit l'heure du dernier remplacement d'appât",
        lastReplacement: "Dernier remplacement d'appât",
        baitLowCount: "Nombre total de consommation d'appât",
        activityCount: "Nombre total d'activités",
        activitiesThreshold: "Seuil d'activité",
        last: 'dernier/dernière',
        lastThresholdReset: "Dernière réinitialisation du seuil d'activité",
        activities: 'Activités',
        activitiesSummary: 'Résumé des activités',
        trackActivitiesInsights: 'Aperçu des activités',
        bait: 'Appât',
        baitAvailable: 'Appât disponible',
        baitLow: "Niveau d'appât faible",
        baitStatusDebounceInfo:
            "Les statuts « Niveau d'appât faible » et « Appât disponible » ne sont mis à jour qu'après {{minutes}} minutes sans mouvement détecté sur la plaque d'appât. Lors de l'installation de l'appareil, activez le <bold>Mode maintenance</bold> afin que le statut s'affiche en temps réel.",
        manufacturerAndType: 'Fabricant / Type',
        overrideLocationSettings:
            'Utiliser des valeurs de surveillance distinctes pour cet appareil',
        overrideLocationSettingsDescription:
            'Activez cette option si cet appareil nécessite des valeurs de poids d’appât ou d’activité différentes de celles des autres appareils de cet emplacement. Ces valeurs restent actives jusqu’à ce que vous désactiviez cette option ou réinitialisiez l’appareil.',
        deviceSettingsSource: 'Utilise les paramètres de l’appareil',
        monitoringValuesSetForLocation: 'Utilise les paramètres de',
        baitAndActivitySettings: 'Paramètres d’appât et d’activité',
        locationSettingsOverrideMoveWarningTitle:
            'Conserver les paramètres distincts ?',
        locationSettingsOverrideMoveWarningText:
            'Un ou plusieurs appareils sélectionnés ont leurs propres paramètres de poids d’appât ou d’activité. Après le déplacement, ces paramètres resteront sur les appareils. Les paramètres du nouvel emplacement ne seront pas appliqués.',
        locationSettingsOverrideMoveConfirm:
            'Déplacer et conserver les paramètres'
    },
    simCards: {
        simCard: 'Carte SIM',
        simCardSerialNumber: 'Numéro de carte SIM',
        activate: 'Activer',
        deactivate: 'Désactiver',
        addSimCardLabel: 'Ajouter une carte SIM',
        addSimCardTooltipText:
            "Aucune carte SIM n'est attribuée à cet appareil réseau. Vous pouvez l'ajouter manuellement",
        simCardEmptyError: 'Ne peut pas être vide',
        simCardNotValidIccidError: 'Format numéro de carte SIM non valide',
        pendingStatusText:
            "Le statut de la carte SIM est en cours de modification, cela peut prendre jusqu'à 5 minutes",
        standByStatusText:
            'La carte SIM attend de transmettre des données et deviendra active une fois cela fait',
        billingDetails: {
            totalSimCardsText: 'Dispositifs réseau activés',
            totalSimCardsTextItalic: '(Mois en cours)',
            billing: 'Facturation',
            tooltipText:
                'Le montant sera automatiquement déduit de votre compte le dernier jour de chaque mois',
            currencySymbol: '€'
        }
    },
    reports: {
        sentAutomatically: 'Envoyé automatiquement',
        noSharingHistory: 'Aucun historique de partage',
        sharingHistory: 'Historique de partage',
        sharedBy: 'par',
        toEmails: 'à',
        ccEmails: 'cc',
        filterFrom: 'De',
        filterTo: 'À',
        allReports: 'Tous les rapports',
        reports: 'Rapports',
        deviceName: 'Nom de l’appareil',
        deviceSerial: 'Numéro de série de l’appareil',
        event: 'Événement',
        time: 'Heure',
        location: 'Emplacement',
        organisation: 'Organisation',
        status: 'Statut',
        type: 'Type',
        share: 'Partager',
        sendMessage: 'Envoyer un message',
        message: 'Message',
        cancle: 'Annuler',
        send: 'Envoyer',
        sendReport: 'Envoyer le rapport',
        emailSentSuccess: 'E-mail envoyé avec succès',
        emailSentFail: 'Oups, quelque chose s’est mal passé',
        on: ' le ',
        sentAt: 'Envoyé à : ',
        failToSend: 'Échec de l’envoi : ',
        mailMessageBegin: 'Madame, Monsieur,',
        mailMessageMainSection:
            'Nous avons détecté une activation du piège à cliquetis ',
        mailMessageMainSection2: '',
        mailMessageMainSection3:
            'Veuillez vérifier le piège pour voir si une capture a été effectuée.',
        mailMessageEnd: 'Cordialement,',
        mailMessageEnd2: 'FA. Fleschhut',
        noReportsYet: 'Aucun rapport pour le moment',
        noReportsForRange: 'Aucun rapport pour la plage horaire sélectionnée',
        reportTime: 'Heure du rapport',
        evaluationTime: 'Heure d’évaluation',
        reportTypes: {
            0: 'Installation réussie',
            1: 'Redémarré',
            2: 'Déclenché',
            3: 'Armé',
            '3-bait': 'Appât disponible',
            4: 'Perte de signal',
            5: 'Hors ligne',
            6: 'Localisation en cours',
            7: 'Échec de localisation',
            8: 'Paramètres mis à jour',
            9: 'Mise à jour réussie',
            10: 'Batterie faible',
            11: 'En ligne à nouveau',
            12: 'Éteint',
            13: 'Connexion instable',
            14: 'Infesté',
            15: 'Légèrement infesté',
            16: 'Lourdement infesté',
            17: 'Déclenchement erroné',
            18: 'Activité (Avertissement)',
            19: 'Activité (Critique)',
            20: 'Capture',
            21: 'Activité détectée',
            22: "Seuil d'activité atteint",
            23: 'Appât faible',
            24: "Seuil d'activité atteint et appât faible",
            25: "Seuil d'activité réinitialisé"
        },
        reportTypesDescription: {
            0: 'Le périphérique a redémarré et les nouvelles données Wifi ont été transférées avec succès.',
            1: 'Le périphérique a redémarré.',
            2: 'Un piège à souris a été déclenché et nécessite une inspection manuelle.',
            3: 'Les pièges à souris sont armés et le périphérique est prêt pour la prochaine capture.',
            '3-bait': "De l'appât est disponible sur le plateau d'appât.",
            4: "Il pourrait y avoir des problèmes de connexion: Le périphérique n'a pas pu atteindre le serveur pendant l'intervalle de battement choisi.",
            5: "Il y a des problèmes de connexion: Le périphérique n'a pas pu atteindre le serveur pendant une période prolongée et nécessite une vérification manuelle sur place.",
            6: 'Le périphérique est en mode balise et peut être localisé',
            7: "Le périphérique n'a pas pu initier le mode balise",
            8: "Les paramètres du périphérique (par exemple, l'intervalle de battement ou/et le mode de fonctionnement) ont été modifiés.",
            9: 'Une mise à jour du micrologiciel du périphérique a été effectuée avec succès.',
            10: 'Le niveau de batterie de ce périphérique est faible. Veuillez changer les piles.',
            11: "Le périphérique est de retour en ligne, il n'y a plus de problèmes de connexion.",
            12: 'Le périphérique a été éteint.',
            13: "Il semble y avoir des problèmes de connexion: La connexion à l'emplacement de ce périphérique semble être peu fiable.",
            14: 'Un utilisateur a signalé une infestation (capture) pour ce périphérique.',
            15: 'Un utilisateur a signalé une infestation légère pour ce périphérique.',
            16: 'Un utilisateur a signalé une infestation importante pour ce périphérique.',
            17: 'Un déclenchement intempestif a été signalé pour cet appareil.',
            18: 'Un utilisateur a signalé une activité sur ce périphérique.',
            19: 'Un utilisateur a signalé une activité critique sur ce périphérique.',
            20: 'Une capture a été détectée. Vérification manuelle requise.',
            21: 'Une activité a été détectée',
            22: "Le seuil d'activité défini a été atteint",
            23: "Le niveau d'appât est faible",
            24: "Le seuil d'activité défini a été atteint et le niveau d'appât est faible",
            25: "Le seuil d'activité a été réinitialisé manuellement"
        },
        info: 'Info',
        warning: 'Avertissement',
        critical: 'Critique',
        infested: 'Infesté',
        infestedDescription: "Afficher les événements d'infestation",
        catch: 'Capture',
        triggered: 'Déclenché',
        triggeredDescription: 'Afficher les événements déclenchés',
        connectivity: 'Connectivité',
        connectivityDescription: 'Afficher la connectivité par appareil',
        catchDescription: 'Description de capture',
        settings: 'Paramètres',
        at: ' à ',
        comments: 'Commentaires',
        edit: 'Modifier',
        delete: 'Supprimer',
        save: 'Enregistrer',
        deleteConfirmation:
            'Êtes-vous sûr(e) de vouloir supprimer le commentaire?',
        addComment: '+ Ajouter un commentaire',
        commentsAvailable: 'Il y a des commentaires pour ce rapport',
        enterCommentPlaceholder: 'Entrez un commentaire...',
        commentEmptyEx: 'Veuillez entrer un commentaire',
        somethingWentWrong:
            'Quelque chose s’est mal passé lors de la capture de captures d’écran du plan d’étage',
        exportDenyMsg:
            'Veuillez sélectionner une plage horaire pour l’exportation de moins de 3 mois.Vous pouvez le définir dans les filtres.La plage horaire actuelle est trop grande pour l’exportation.',
        changeRTToFT: 'Changer le type de rapport en faux déclenchement',
        changeRTToFTDescr:
            'Le piège est vide ? Veuillez ajouter un commentaire et éventuellement une photo du piège. Après confirmation, ce rapport de capture sera changé en rapport de faux déclenchement',
        changeRTToCatch: 'Changer le type de rapport en capture',
        changeRTToCatchDescr:
            'Il y a une capture dans le piège ? Veuillez ajouter un commentaire et éventuellement une photo du piège. Après confirmation, ce rapport de faux déclenchement sera changé en rapport de capture'
    },
    userManagement: {
        userManagement: 'Gestion des utilisateurs',
        users: 'Utilisateurs',
        roles: 'Rôles',
        roleName: 'Nom du rôle',
        customer: 'Organisation',
        actions: 'Actions',
        createNew: 'Créer un nouveau',
        addFromAnotherOrg: 'Ajouter à partir d’une autre organisation',
        noUsersFound: 'Aucun utilisateur trouvé',
        emailIsEmpty: 'L’e-mail est vide',
        isNotEmail: ' n’est pas un e-mail',
        fillInEmail:
            'Veuillez saisir l’adresse e-mail de l’utilisateur d’une autre organisation.',
        onlyToYourOrg:
            'Vous pouvez ajouter un utilisateur uniquement à votre organisation',
        chooseRole: 'Veuillez choisir un rôle pour l’utilisateur',
        verify: 'Vérifier',
        add: 'Ajouter',
        whichOrgToCreateUser:
            'Dans quelle organisation voulez-vous créer un utilisateur?',
        create: 'Créer',
        pickOrgToDeleteUser:
            'Veuillez sélectionner l’organisation dont vous voulez supprimer l’utilisateur',
        sureDeleteUser: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
        sureDeleteUsers:
            'Êtes-vous sûr de vouloir supprimer ces utilisateurs ?',
        nameIsTooShort: 'Le nom est trop court',
        emailIsNotCorrect: 'L’e-mail n’est pas correct',
        genPassword: 'Générer un mot de passe',
        changePassword: 'Changer le mot de passe',
        noRolesFound: 'Aucun rôle trouvé',
        component: 'Composant',
        read: 'Lire',
        update: 'Mettre à jour',
        delete: 'Supprimer',
        roleNotFound: 'Le rôle n’a pas été trouvé',
        defaultRoles: {
            [DEFAULT_ROLES.traplinked_admin]: 'Administrateur traplinked',
            [DEFAULT_ROLES.customer_admin]: 'Administrateur d’organisation',
            [DEFAULT_ROLES.viewer]: 'Lecteur',
            [DEFAULT_ROLES.management_user]: 'Utilisateur de gestion',
            [DEFAULT_ROLES.read_only_user]: 'Utilisateur en lecture seule',
            [DEFAULT_ROLES.location_management_user]:
                'Utilisateur de gestion de localisation',
            [DEFAULT_ROLES.technician]: 'Technicien'
        },
        youCanNotDeleteThisUser: 'Vous ne pouvez pas supprimer cet utilisateur',
        youCanNotDeleteThisRole: 'Vous ne pouvez pas supprimer ce rôle',
        internalUser: 'Utilisateur interne',
        externalUser: 'Utilisateur externe',
        createUserModalTitle: 'Créer un nouvel utilisateur',
        createExternalTitle: 'Créer un utilisateur externe',
        createInternalTitle: 'Créer un utilisateur interne',
        userRalationStepTitle: 'Choisir la relation utilisateur',
        credentialsStepTitle: 'Identifiants de connexion',
        createRoleStepTitle: 'Créer un rôle personnalisé',
        selectRoleStepTitle: 'Choisir un rôle pour l’utilisateur',
        selectLocationsStepTitle: 'Choisir des emplacements',
        reviewStepTitle: 'Révision finale',
        nextStep: 'Étape suivante',
        stepBack: 'Étape précédente',
        completeBtn: 'Terminer',
        backToDefaultRoles: 'Retour aux rôles par défaut',
        userRalationOptionName: {
            [USER_RELATIONS.internal]: 'Interne',
            [USER_RELATIONS.external]: 'Externe'
        },
        userRalationOptionDescription: {
            [USER_RELATIONS.internal]:
                'Nouveau compte utilisateur pour une personne travaillant dans votre organisation, convient à vos employés qui n’ont pas encore de compte dans le système traplinked',
            [USER_RELATIONS.external]:
                'Nouveau compte utilisateur / accès à votre organisation depuis une organisation externe, convient aux entrepreneurs qui n’ont pas encore de compte utilisateur ou qui en ont déjà un'
        },
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        password: 'Mot de passe',
        customerName: 'Nom de l’organisation',
        userRelationExplanation: {
            [RELATIONS.internal]:
                'L’utilisateur avec cette adresse e-mail existe déjà dans votre organisation en tant qu’utilisateur interne',
            [RELATIONS.externalIn]:
                'L’utilisateur avec cette adresse e-mail existe déjà dans votre organisation en tant qu’utilisateur externe',
            [RELATIONS.externalOut]:
                'Vous ne pouvez ajouter cet utilisateur à l’organisation qu’en tant qu’utilisateur externe. Voulez-vous continuer?',
            [RELATIONS.nonexistent]: ''
        },
        roleNames: {
            [DEFAULT_ROLES.customer_admin]: 'Administrateur',
            [DEFAULT_ROLES.viewer]: 'Observateur',
            [DEFAULT_ROLES.management_user]: 'Gestionnaire',
            [DEFAULT_ROLES.technician]: 'Technicien',
            [CUSTOM_ROLE]: 'Personnalisé'
        },
        roleDescription: {
            [DEFAULT_ROLES.customer_admin]:
                'Tous les droits sur le système : peut gérer les emplacements, les appareils, les utilisateurs, et autres',
            [DEFAULT_ROLES.viewer]:
                'Pas d’accès à la gestion des utilisateurs, ne peut que lire et afficher les emplacements assignés, voir l’état des appareils, les rapports des emplacements assignés',
            [DEFAULT_ROLES.management_user]:
                'Peut créer et gérer les emplacements mais ne peut pas les supprimer, peut gérer les appareils, les rapports, peut gérer les utilisateurs mais ne peut pas les supprimer',
            [DEFAULT_ROLES.technician]:
                'Pas d’accès à la gestion des utilisateurs, peut créer, gérer et supprimer les emplacements assignés, peut gérer les appareils et les rapports des emplacements assignés',
            [CUSTOM_ROLE]: 'Rôle personnalisable'
        },
        createNewCustomrole: '+ Créer un nouveau Rôle Personnalisé',
        selectExistingCustomRole: 'Sélectionner le rôle personnalisé',
        deselectAllLocations: 'Tout désélectionner',
        selectAllLocations: 'Tout sélectionner',
        showTheUserInTheList: 'afficher l’utilisateur dans la liste',
        youCanProceedWithRoleSelection:
            'Vous pouvez procéder à la sélection du rôle pour cet utilisateur externe',
        sendInvitationMail: "Envoyer l'invitation par courrier électronique",
        invitationModalText:
            "Êtes-vous sûr de vouloir envoyer l'invitation à cet utilisateur ?",
        usersStillAssigned: 'Les utilisateurs sont toujours affectés à ce rôle',
        usersAssignedTheRole:
            'Il y a encore des utilisateurs auxquels est attribué le rôle que vous voulez supprimer',
        reassignThatUsers:
            'Veuillez réassigner un autre rôle à cet utilisateur avant de le supprimer.',
        deleteRoleConfirmation: 'Êtes-vous sûr de vouloir supprimer ce rôle ?',
        reassignAndDeleteModal: {
            header: 'Des utilisateurs sont toujours assignés à ce rôle',
            textOne:
                'Il y a toujours des utilisateurs assignés au rôle que vous souhaitez supprimer',
            textTwo:
                'Veuillez réaffecter ces utilisateurs à un autre rôle avant de supprimer celui-ci'
        }
    },
    sharing: {
        sharing: 'Partage',
        chooseUsers: 'Choisir des utilisateurs',
        chooseItems: 'Choisir les éléments à partager',
        confirmAndShare: 'Confirmer et partager',
        organisation: 'Organisation',
        noUsersToShare:
            'Actuellement, aucun utilisateur n’a été ajouté depuis une autre organisation.',
        pleaseAddUsers:
            'Veuillez ajouter des utilisateurs depuis une autre organisation',
        userMgmt: 'Gestion des utilisateurs',
        noUsersLeft: 'Aucun utilisateur à sélectionner',
        noUsersSelected:
            'Aucun utilisateur n’a encore été sélectionné pour le partage',
        locations: 'Emplacements',
        devices: 'Dispositifs',
        reports: 'Rapports',
        serialNr: 'Numéro de série',
        noDevicesToShare:
            'Actuellement, aucun dispositif n’est disponible pour le partage',
        noDevicesLeft: 'Aucun dispositif à sélectionner',
        noDevicesSelected:
            'Aucun dispositif n’a encore été sélectionné pour le partage',
        noReportsToShare:
            'Actuellement, aucun rapport n’est disponible pour le partage',
        noReportsLeft: 'Aucun rapport à sélectionner',
        noReportsSelected:
            'Aucun rapport n’a encore été sélectionné pour le partage',
        address: 'Adresse',
        noLocationsToShare:
            'Actuellement, aucun emplacement n’est disponible pour le partage',
        contactSupport:
            'Si vous voyez ce message, veuillez contacter le support',
        noLocationsLeft: 'Aucun emplacement à sélectionner',
        noLocationsSelected:
            'Aucun emplacement n’a encore été sélectionné pour le partage',
        willBeSharedWith: 'Sera partagé avec:',
        successShare: 'Partage réussi'
    },
    detachedSharing: {
        noDataToShare: 'Actuellement, il n’y a pas de données à partager',
        chooseUsers: 'Choisir des utilisateurs',
        chooseItems: 'Choisir les éléments à partager',
        confirmAndShare: 'Confirmer et partager',
        noDevicesSetupYet:
            'Aucun appareil n’a été configuré sur cet emplacement pour l’instant.',
        devicesSelected: 'Appareils sélectionnés',
        locationsSelected: 'Emplacements sélectionnés',
        selected: 'Sélectionné',
        shareWithUsers: 'Partager avec des utilisateurs',
        existingFromAnotherOrg: 'ajoutés par une autre organisation',
        byEmailFromAnotherOrg: 'par e-mail',
        noUsersToShare:
            'Actuellement, il n’y a aucun utilisateur ajouté par une autre organisation. Vous pouvez partager par e-mail.',
        usersSelected: 'Utilisateurs sélectionnés',
        plsTypeInEmail: 'Veuillez saisir une adresse e-mail valide',
        chooseRole: 'Veuillez choisir un rôle',
        addUsersEmails: 'Ajouter des adresses e-mail d’utilisateurs',
        location: 'Emplacement',
        device: 'Appareil',
        serialNr: 'Numéro de série',
        dataForSharing: 'Données à partager',
        willBeSharedWith: 'Seront partagés avec',
        locationsPath: 'Chemin des emplacements',
        nothingFound: 'Rien trouvé'
    },
    settings: {
        faq: 'FAQ',
        language: 'Langue',
        settings: 'Paramètres',
        logout: 'Déconnexion',
        emailNotificationsEnabled: 'Notifications par e-mail',
        pushNotificationsEnabled: 'Notifications push',
        smsNotificationsEnabled: 'Notifications SMS',
        trapsTriggeredNotificationsEnabled: 'Déclenchement de pièges',
        trapsInactiveemailNotificationsEnabled: 'Appareil désactivé',
        batteryEmptyNotificationsEnabled: 'Batterie faible',
        batterySetupNotificationsEnabled: 'Appareil installé',
        trapOnlineNotificationsEnabled: 'Appareil en ligne',
        unstableConnectionNotificationsEnabled:
            'Connexion instable de l’appareil',
        baitLowNotificationsEnabled: "L'appareil a un niveau d'appât faible",
        activityThresholdReachedNotificationsEnabled:
            "L'appareil a atteint le seuil d'activité",
        baitLowAndActivityThresholdReachedNotificationsEnabled:
            "L'appareil a un niveau d'appât faible et a atteint le seuil d'activité",
        acceptSharedData: 'Mise à jour des données partagées',
        notificationsChannels: 'Types de notifications',
        notificationsEvents: 'Notifications',
        nameIsTooShort: 'Le nom est trop court',
        phoneNumberErr: 'Le numéro de téléphone n’est pas valide',
        organisationPhoneNumberErr:
            'Le numéro de téléphone de l’organisation n’est pas valide',
        reportBug: 'Signaler un bogue',
        viewOurRoadmap: 'Voir notre feuille de route',
        voteOnNewFeatures: 'Vote sur les nouvelles fonctionnalités',
        termsOfService: "Conditions d'utilisation",
        termsConditions: "Conditions générales d'utilisation",
        privacyPolicy: 'Politique de confidentialité',
        simCards: 'Cartes SIM',
        billingPortal: 'Facturation',
        portalError:
            'Erreur lors du chargement du portail de facturation Stripe'
    },
    login: {
        emailIsRequired: 'L’adresse e-mail est requise pour se connecter',
        passwordIsRequired: 'Le mot de passe est requis pour se connecter',
        forgotPassword: 'Mot de passe oublié ?',
        signIn: 'Se connecter',
        newInTraplinked: 'Nouveau client ? Veuillez vous inscrire.'
    },
    twoFactor: {
        title: 'Authentification à deux facteurs',
        helperText:
            'Entrez le code à 6 chiffres que nous avons envoyé à votre adresse e-mail',
        verify: 'Vérifier',
        backToLogin: 'Retour à la connexion'
    },
    resetPassword: {
        resetPassword: 'Réinitialiser le mot de passe',
        backToLogin: 'Retour à la connexion',
        goToLogin: 'Aller à la connexion',
        passwordIsTooShort: 'Le mot de passe est trop court',
        passwordsDoNotMatch: 'Les mots de passe ne correspondent pas'
    },
    register: {
        nameIsTooShort: 'Le nom est trop court',
        emailIsNotCorrect: 'L’adresse e-mail n’est pas correcte',
        passwordIsTooShort: 'Le mot de passe est trop court',
        passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
        registerUser: 'Inscrire un utilisateur',
        haveAlreadyUser: 'Vous avez déjà un compte ? Veuillez vous connecter.',
        pleaseEnterOrgName:
            'Veuillez saisir le nom de votre organisation, c’est obligatoire',
        orgName: 'Nom de l’organisation',
        registerOrg: 'Inscrire l’organisation',
        everythingIsReady:
            'Votre nouveau utilisateur et nouvelle organisation sont prêts, vous pouvez maintenant vous connecter',
        goToLogin: 'Aller à la connexion',

        registerYourOrganization: 'Enregistrez votre organisation',
        youAreAPestController:
            'Vous êtes un contrôleur de nuisibles et souhaitez enregistrer votre organisation',
        alreadyHaveAnAccount: 'Vous avez déjà un compte ?',
        login: 'Se connecter',
        or: 'ou',
        joinAnExistingOrganization: 'Rejoindre une organisation existante ?',
        accessYourOrganization:
            "Si vous êtes un technicien ou un membre de l'équipe et que vous souhaitez accéder à votre organisation, demandez à votre administrateur de vous inviter.",
        notSureWhoYourAdmin:
            "Vous ne savez pas qui est votre administrateur ou vous rencontrez des problèmes ? Contactez notre équipe de support pour obtenir de l'aide."
    },
    apiKeys: {
        apiKeys: 'Clés API',
        apiKey: 'Clé API',
        viewDocs: 'View REST docs',
        copied: 'Copié',
        failedToCopy: 'Échec de la copie',
        createNew: 'Créer une nouvelle',
        expires: 'Expire',
        noApiKeysFound: 'Aucune clé API trouvée',
        plsProvideDescr: 'Veuillez fournir la description de la clé API',
        deleteKeyDescr:
            'Si vous supprimez cette clé API, l’accès aux données via cette clé API ne sera plus possible. Êtes-vous sûr de vouloir supprimer cette clé API ?',
        viewKeyDescr:
            'Entrez la clé API dans le logiciel tiers pour qu’il puisse afficher les données de votre appareil. Si le fabricant propose une fonction correspondante, vous pouvez également scanner le code QR pour saisir la clé API.'
    },
    integrations: {
        integrations: 'Intégrations',
        documentationTools: 'Outils de documentation',
        apiKeys: 'Clés API',
        pestsoft: 'Pestsoft',
        debuxx: 'DEBUXX',
        pestscan: 'Pestscan',
        pestscanPcoId: 'Pestscan PCO ID',
        username: 'Nom d’utilisateur',
        enterPassword: 'Saisissez le mot de passe',
        credentialsRequired:
            'Saisissez et enregistrez les identifiants pour finaliser la connexion.',
        pestscanPcoIdRequiredWhenEnabled:
            'Le PCO ID est requis lorsque Pestscan est activé.',
        debuxxHint: {
            toggle: 'Comment obtenir ces identifiants ?',
            title: 'Créer un utilisateur API DEBUXX',
            body: 'Les administrateurs peuvent créer un utilisateur API dans DEBUXX via **Einstellungen → Erweiterungen** en choisissant un nom d’utilisateur et un mot de passe. Copiez-les ici pour vous connecter.',
            support:
                'Besoin d’aide supplémentaire ? Contactez le support DEBUXX si vous avez d’autres questions sur la création ou la récupération de ces identifiants.'
        },
        pestscanHint: {
            toggle: 'Comment obtenir mon PCO ID ?',
            title: 'Créer un profil PC40 dans Pestscan',
            steps: {
                1: 'Accédez à **General Settings** via la roue dentée dans la barre de navigation principale.',
                2: 'Sélectionnez **Permanent Monitoring** dans le menu.',
                3: 'Ouvrez l’onglet **Profiles** et cliquez sur **New**.',
                4: 'Définissez **Description** sur quelque chose de clair, par exemple PC40.',
                5: 'Définissez **Type** sur PC40.',
                6: 'Cliquez sur **Save**.',
                7: 'Copiez le **PCO ID** obtenu et collez-le ici.'
            },
            support:
                'Besoin d’aide supplémentaire ? Contactez le support Pestscan si vous avez d’autres questions sur l’obtention de votre PCO ID.'
        },
        settingsUpdated: 'Paramètres d’intégration mis à jour',
        settingsUpdateFailed:
            'Échec de la mise à jour des paramètres d’intégration',
        loadFailed: 'Échec du chargement des paramètres d’intégration',
        summaryTitle: 'Aperçu des intégrations et de l’API',
        apiKeysCount: 'Clés API',
        webhooks: 'Webhooks',
        webhooksTab: {
            title: 'Webhooks',
            viewDocs: 'Voir la documentation des webhooks',
            createWebhook: 'Créer un webhook',
            editWebhook: 'Modifier le webhook',
            deleteWebhook: 'Supprimer le webhook',
            confirmDeleteWebhook:
                'Cela supprimera définitivement le webhook. Cette action est irréversible.',
            noWebhooksFound: 'Aucun webhook pour le moment',
            emptyBody:
                'Les webhooks livrent les événements des appareils en temps réel à vos endpoints. Créez-en un pour commencer à recevoir des données.',
            editorSubtitle:
                'Les webhooks livrent les événements des appareils en temps réel',
            webhookCreated: 'Webhook créé',
            webhookUpdated: 'Webhook mis à jour',
            webhookDeleted: 'Webhook supprimé',
            createFailed: 'Échec de la création du webhook',
            updateFailed: 'Échec de la mise à jour du webhook',
            deleteFailed: 'Échec de la suppression du webhook',
            loadFailed: 'Échec du chargement des webhooks',
            statusEnabled: 'Activé',
            statusDisabled: 'Désactivé',
            saveChanges: 'Enregistrer les modifications',
            cancel: 'Annuler',
            never: '--',
            fields: {
                status: 'Statut',
                name: 'Nom',
                description: 'Description',
                endpoint: 'URL',
                webhookType: 'Type',
                requestMethod: 'Méthode',
                reasons: 'Types de rapport',
                reasonSingular: 'type de rapport',
                reasonPlural: 'types de rapport',
                reasonsTotalSuffix: 'disponibles',
                isEnabled: 'Activé',
                isEnabledHint:
                    'Lorsqu’il est activé, les rapports correspondant aux types sélectionnés sont livrés.',
                headers: 'En-têtes',
                lastResponse: 'Dernière réponse',
                lastResponseCode: 'Code de la dernière réponse',
                lastRequestTimestamp: 'Dernière requête'
            },
            placeholders: {
                name: 'Mon webhook',
                endpoint: 'https://example.com/webhooks/traplinked',
                description: 'À quoi sert ce webhook ?',
                reasonsEmpty: 'Sélectionnez un ou plusieurs types de rapport…'
            },
            headers: {
                keyHeader: 'Clé',
                valueHeader: 'Valeur',
                keyPlaceholder: 'p. ex. Authorization',
                valuePlaceholder: 'Valeur',
                addRow: 'Ajouter un en-tête',
                removeRow: 'Supprimer l’en-tête',
                maskedHint: '•••••• ressaisir pour remplacer',
                renamedHint: 'Renommé — ressaisissez la valeur',
                versionRequired: 'Obligatoire',
                versionLatestHint: 'la plus récente est',
                versionLatestSuffix: 'la plus récente',
                empty: 'Aucun en-tête personnalisé. Ajoutez-en un pour authentifier vos requêtes.'
            },
            validation: {
                nameRequired: 'Le nom est obligatoire',
                endpointRequired: 'L’URL est obligatoire',
                reasonsRequired: 'Sélectionnez au moins un type de rapport',
                headerKeyRequired: 'La clé de l’en-tête est obligatoire',
                headerValueRequired: 'La valeur de l’en-tête est obligatoire',
                headerKeyDuplicate: 'Les clés d’en-tête doivent être uniques',
                versionReserved:
                    'traplinked-Version se définit ci-dessus, pas comme en-tête personnalisé'
            },
            reasonGroupLabels: {
                device: 'État de l’appareil',
                trap: 'Événements de piège',
                image: 'Images',
                heartbeat: 'Heartbeat',
                activity: 'Activité et appât'
            },
            reasonLabels: {
                image_received: 'Image reçue',
                image_ai_processed: 'Image traitée par IA',
                heartbeat_received: 'Heartbeat reçu',
                trap_triggered: 'Piège déclenché',
                battery_low: 'Batterie faible',
                catch_detected: 'Capture détectée',
                rearmed: 'Réarmé',
                offline: 'Hors ligne',
                online: 'En ligne',
                configured: 'Configuré (configuration initiale en usine)',
                maintained: 'Entretenu (service en usine)',
                switched_off: 'Éteint',
                catch_reported: 'Capture signalée',
                false_triggering: 'Faux déclenchement',
                activity_noticed: 'Activité détectée',
                activity_threshold_reached: 'Seuil d’activité atteint',
                bait_low: 'Niveau d’appât bas',
                activity_threshold_reached_and_bait_low:
                    'Seuil d’activité atteint et niveau d’appât bas'
            },
            typeLabels: {
                traplinked: 'traplinked',
                rentokil_tom_images: 'Rentokil images TOM',
                pestsoft: 'Pestsoft',
                axinsectai: 'AxInsectAI'
            },
            methodLabels: {
                post: 'POST',
                put: 'PUT',
                patch: 'PATCH',
                get: 'GET',
                delete: 'DELETE'
            }
        },
        billingNotice:
            'Les intégrations et clés API actives coûtent 0,10 € par appareil et par mois pour les appareils ayant émis au moins un signal depuis le premier jour du mois. Les appareils créés le 31.12.2024 ou avant sont exonérés.',
        openBillingDashboard: 'Ouvrir le tableau de bord de facturation',
        billingDataLoadFailed:
            'Échec du chargement de l’aperçu des intégrations et de la facturation',
        billingModalTitle: 'Cette activation impacte votre facturation',
        billingModalIntro:
            'Activer une intégration, une clé API ou un webhook déclenche la facturation pour votre organisation. Détails :',
        billingModalRulePrice: 'Coût : 0,10 € par appareil et par mois',
        billingModalRuleHeartbeat:
            'Seuls les appareils ayant émis au moins un signal (heartbeat) durant le mois sont facturés',
        billingModalRuleGrandfathered:
            'Les appareils en ligne depuis ou avant le 31.12.2024 n’engendrent aucun coût',
        billingModalConfirm: 'J’accepte, activer',
        billingModalCancel: 'Annuler'
    },
    sagasMsgs: {
        /* common */
        getReportSharingHistoryEx: 'Erreur lors de la récupération des données',
        commonLoadingError: 'Une erreur s’est produite. Veuillez réessayer',
        /* login */
        loginEx: 'Les données de connexion sont incorrectes',
        loginWithTsEx:
            'Une erreur s’est produite, veuillez contacter le support.',
        sessionEx: 'Votre session a expiré',
        verify2faEx: 'Code invalide ou expiré. Veuillez réessayer.',
        updataProfileRes: 'Le profil a été mis à jour.',
        updataProfileEx: 'Erreur lors de la mise à jour du profil',
        pswdChangeRes: 'Le mot de passe a été modifié.',
        pswdChangeEx:
            'Erreur lors du changement de mot de passe, assurez-vous que l’ancien mot de passe est correct.',
        forgotPswdRes:
            'Un lien pour réinitialiser votre mot de passe a été envoyé à votre adresse e-mail.',
        forgotPswdEx:
            'Une erreur s’est produite lors de la demande de réinitialisation du mot de passe',
        resetPswdRes:
            'Le mot de passe a été changé avec succès, vous pouvez maintenant vous connecter.',
        resetPswdEx:
            'Une erreur s’est produite, veuillez réessayer de réinitialiser le mot de passe sur la page de connexion',
        saveLocaleEx:
            'Une erreur s’est produite lors de la tentative de sauvegarde des paramètres de langue.',
        /* customers */
        getCustomersEx:
            'Une erreur s’est produite lors du chargement des clients',
        getCustomerEx: 'Une erreur s’est produite lors du chargement du client',
        updateCustomerEx:
            'Une erreur s’est produite lors de la mise à jour du client',
        updateCustomerRes: 'Le client a été mis à jour avec succès',
        getSoftwarePlansEx:
            'Une erreur s’est produite lors du chargement des plans logiciels',
        /* locations */
        getLocationsEx:
            'Une erreur s’est produite lors du chargement des emplacements',
        getLocationEx:
            'Une erreur s’est produite lors du chargement de l’emplacement',
        updateLocationRes: 'L’emplacement a été mis à jour avec succès',
        updateLocationEx:
            'Une erreur s’est produite lors de la mise à jour de l’emplacement',
        createLocationRes: 'L’emplacement a été créé avec succès',
        createLocationEx:
            'Une erreur s’est produite lors de la création de l’emplacement',
        deleteLocationRes: 'Suppression de l’emplacement réussie',
        deleteLocationEx:
            'Une erreur s’est produite lors de la suppression de l’emplacement',
        shareLocationRes: 'Partage réussi',
        shareLocationEx:
            'Une erreur s’est produite lors du partage de l’emplacement',
        getLocationDevicesEx:
            'Une erreur s’est produite lors de l’obtention des périphériques de l’emplacement',
        getLocationReportsEx:
            'Une erreur s’est produite lors de l’obtention des rapports de l’emplacement',
        getLocationSharedUsersEx:
            'Une erreur s’est produite lors de l’obtention des informations de partage de l’emplacement',
        getAvailableDevicesEx:
            'Une erreur s’est produite lors du chargement des périphériques disponibles à ajouter',
        moveDevicesRes:
            'Les périphériques ont été ajoutés avec succès à l’emplacement',
        moveDevicesEx:
            'Une erreur s’est produite lors de l’ajout des périphériques à l’emplacement',
        createFloorPlanRes: 'Le plan d’étage a été créé avec succès',
        createFloorPlanEx:
            'Une erreur est survenue lors de la création du plan d’étage',
        getFloorPlanEx:
            'Une erreur est survenue lors du chargement du plan d’étage',
        deleteFloorPlanRes: 'Le plan d’étage a été supprimé avec succès',
        deleteFloorPlanEx:
            'Une erreur est survenue lors de la suppression du plan d’étage',
        getFPAvailableDevicesEx:
            'Une erreur est survenue lors du chargement des appareils disponibles à ajouter au plan d’étage',
        addDevicesToFPEx:
            'Une erreur est survenue lors de l’ajout des appareils au plan d’étage',
        updateFPDeviceEx:
            'Une erreur est survenue lors de la mise à jour de l’appareil du plan d’étage',
        deleteFPDeviceEx:
            'Une erreur est survenue lors de la suppression de l’appareil du plan d’étage',
        /* devices */
        getDevicesEx:
            'Une erreur est survenue lors du chargement des appareils',
        getDeviceEx: 'Une erreur est survenue lors du chargement de l’appareil',
        getDeviceReportsEx:
            'Une erreur est survenue lors du chargement des rapports de l’appareil',
        shareDevicesRes: 'Partagé avec succès',
        shareDevicesEx: 'Une erreur est survenue lors du partage de l’appareil',
        resetDeviceRes: 'Appareil réinitialisé avec succès',
        resetDeviceEx:
            'Une erreur est survenue lors de la réinitialisation de l’appareil',
        reportCatchRes: 'Capture signalée avec succès',
        reportCatchEx:
            'Une erreur est survenue lors du signalement de la capture',
        setOfflineRes: 'Mise hors ligne réussie',
        setOfflineEx:
            'Une erreur est survenue lors de la mise hors ligne de l’appareil',
        batteryResetRes: 'Batterie réinitialisée avec succès',
        batteryResetEx:
            'Une erreur est survenue lors de la réinitialisation de la batterie',
        updateDeviceRes: 'Appareil mis à jour avec succès',
        updateDeviceEx:
            'Une erreur est survenue lors de la mise à jour de l’appareil',
        getPestControlSystems:
            'Une erreur est survenue lors du chargement des systèmes de lutte antiparasitaire',
        tomStatusResetRes: 'Réinitialisation du statut réussie',
        tomStatusResetEx:
            'Une erreur est survenue lors de la réinitialisation du statut',
        /* reports */
        getReportsEx: 'Une erreur est survenue lors du chargement des rapports',
        getReportEx: 'Une erreur est survenue lors du chargement du rapport',
        getLastReportDateEx:
            "Une erreur s'est produite lors du chargement de la date du dernier rapport",
        /* gestion des utilisateurs */
        getUsersEx:
            'Une erreur est survenue lors du chargement des utilisateurs',
        getUserEx:
            'Une erreur est survenue lors du chargement de l’utilisateur',
        getRoleEx: 'Une erreur est survenue lors du chargement du rôle',
        createRoleRes: 'Le rôle a été créé avec succès',
        createRoleEx: 'Une erreur est survenue lors de la création du rôle',
        updateRoleRes: 'Le rôle a été mis à jour avec succès',
        updateRoleEx: 'Une erreur est survenue lors de la mise à jour du rôle',
        getRolesEx: 'Une erreur est survenue lors de la récupération des rôles',
        updateUserRes: 'L’utilisateur a été mis à jour avec succès',
        updateUserEx:
            'Une erreur est survenue lors de la mise à jour de l’utilisateur',
        createUserRes: 'L’utilisateur a été créé avec succès',
        createUserEx:
            'Une erreur est survenue lors de la création de l’utilisateur',
        deleteUserRes: 'Supprimé avec succès',
        deleteUserEx:
            'Une erreur est survenue lors de la suppression de l’utilisateur',
        membershipEx:
            'Une erreur est survenue lors de la demande d’adhésion de l’utilisateur',
        addToOrgRes: 'Utilisateur(s) ajouté(s) à l’organisation avec succès',
        addToOrgEx:
            'Une erreur est survenue lors de l’ajout des utilisateurs à l’organisation',
        sendInvitationRes:
            "L'invitation a été envoyée avec succès à l'utilisateur",
        sendInvitationEx:
            "Une erreur s'est produite lors de l'envoi de l'invitation",
        deleteRoleRes: 'Le rôle a été supprimé avec succès',
        deleteRoleEx:
            "Une erreur s'est produite lors de la suppression du rôle",
        /* partage */
        revokeSharingRes: 'L’accès partagé a été révoqué avec succès',
        revokeSharingEx:
            'Une erreur est survenue lors de la révocation de l’accès partagé',
        getSharingDataEx:
            'Une erreur est survenue lors du chargement du composant de partage',
        shareEx: 'Une erreur est survenue lors du partage des entités',
        /* clés API */
        getApiKeysEx: 'Une erreur est survenue lors du chargement des clés API',
        createApiKeyRes: 'La clé API a été créée avec succès',
        createApiKeyEx:
            'Une erreur est survenue lors de la création de la clé API',
        deleteApiKeyRes: 'La clé API a été supprimée avec succès',
        deleteApiKeyEx:
            'Une erreur est survenue lors de la suppression de la clé API',
        getApiKeyEx: 'Une erreur est survenue lors du chargement de la clé API',
        /* register */
        registerUserRes: 'L’utilisateur a été créé avec succès',
        registerUserEx:
            'Une erreur est survenue lors de la création de l’utilisateur',
        registerCustomerRes: 'L’organisation a été créée avec succès',
        pleaseUseEmail:
            'Veuillez utiliser l’email et le mot de passe de votre nouvel utilisateur',
        registerCustomerEx:
            'Une erreur est survenue lors de la création de l’organisation',
        /* detached sharing */
        getDetachedSharingDataEx:
            'Une erreur est survenue lors du chargement des données pour le partage',
        shareDetachedSharingDataRes: 'Partagé avec succès',
        shareDetachedSharingDataEx:
            'Une erreur est survenue lors du partage des entités',
        tomMakeReport: 'Une erreur est survenue lors de la création du rapport',
        getTomPicturesEx:
            'Une erreur est survenue lors du chargement des images TOM',
        mailSendRes: 'Email envoyé avec succès',
        mailSendEx: 'Échec de l’envoi de l’email',
        organisationPhoneEx:
            'Échec de l’enregistrement du numéro de téléphone de l’organisation',
        commentDeleteRes: 'Commentaire supprimé avec succès',
        commentDeleteEx:
            'Une erreur est survenue lors de la suppression du commentaire',
        commentAddRes: 'Commentaire ajouté avec succès',
        commentAddEx: 'Une erreur est survenue lors de l’ajout du commentaire',
        commentEditRes: 'Commentaire modifié avec succès',
        commentEditEx:
            'Une erreur est survenue lors de la modification du commentaire',
        getCommentsEx:
            'Une erreur est survenue lors du chargement des commentaires',
        deviceImagesAddRes: 'Ajouté avec succès',
        deviceImagesAddEx: "Une erreur s'est produite lors de l'ajout de",
        deviceImagesEditRes: 'Édité avec succès',
        deviceImagesEditEx: "Une erreur s'est produite lors de l'édition",
        getDeviceImagesEx: "Une erreur s'est produite lors du chargement",
        getLocationsByCustomerIdEx:
            'An error occurred while loading locations by customer id',
        getEscalationLevelEx:
            "Une erreur s'est produite lors du chargement des niveaux d'escalade",
        postEscalationLevelEx:
            "Une erreur s'est produite lors de la création des niveaux d'escalade",
        postEscalationLevelRes: "Ajout réussi de niveaux d'escalade",
        getDeviceHistoryEx:
            "Une erreur s'est produite lors du chargement de l'historique de l'appareil",
        getUserPreferencesByTypeEx:
            'Erreur lors du chargement des préférences utilisateur',
        patchUserPreferencesEx:
            'Erreur lors de la mise à jour des préférences utilisateur',
        postUserPreferencesEx:
            'Erreur lors de la création des préférences utilisateur',
        exportFileEx: "Erreur lors de l'exportation du fichier",
        getSimCardEx:
            "Une erreur s'est produite lors du chargement de la carte SIM",
        updateSimCardRes: 'La carte SIM a été mise à jour avec succès',
        updateSimCardEx:
            "Une erreur s'est produite lors de la mise à jour de la carte SIM",
        createSimCardRes: 'La carte SIM a été créée avec succès',
        createSimCardEx:
            "Une erreur s'est produite lors de la création de la carte SIM"
    },
    common: {
        maintenanceMode: 'Mode maintenance',
        maintenanceDurationCustom: 'Personnalisé',
        maintenanceDurationMinUnit: 'min',
        maintenanceDurationPositiveOnly:
            'Seuls les nombres entiers positifs sont autorisés',
        maintenanceDurationDecrease: 'Diminuer les minutes',
        maintenanceDurationIncrease: 'Augmenter les minutes',
        maintenanceDurationMinutes: 'Minutes de maintenance',
        exitingMMode: 'Sortie du mode maintenance',
        switchOnMMode: 'Activer le mode maintenance',
        switchOffMMode: 'Désactiver le mode maintenance',
        switchOnMModeDescr:
            'En mode maintenance, les rapports ne sont pas créés et les notifications ne sont pas envoyées.',
        switchOffMModeDescr: 'Le mode maintenance va être désactivé.',
        ok: 'Ok',
        name: 'Nom',
        save: 'Enregistrer',
        search: 'Rechercher',
        cancel: 'Annuler',
        submit: 'Soumettre',
        clear: 'Réinitialiser les filtres',
        phone: 'Téléphone',
        organisationPhone: 'Téléphone de l’organisation',
        email: 'Courriel',
        organisation: 'Organisation',
        role: 'Rôle',
        password: 'Mot de passe',
        passwordConfirmation: 'Confirmation de mot de passe',
        changePassword: 'Changer le mot de passe',
        oldPassword: 'Ancien mot de passe',
        newPassword: 'Nouveau mot de passe',
        newPasswordConfiramtion: 'Confirmation du nouveau mot de passe',
        errorContactSupport:
            'Une erreur est survenue, veuillez contacter le support',
        revoke: 'Révoquer',
        share: 'Partager',
        delete: 'Supprimer',
        back: 'Retour',
        next: 'Suivant',
        confirm: 'Confirmer',
        skip: 'Passer',
        description: 'Description',
        trap: 'Piège',
        fourHours: '4 heures',
        sixHours: '6 heures',
        twelveHours: '12 heures',
        eighteenHours: '18 heures',
        twentyFourHours: '24 heures',
        acceptTerms: 'Accepter',
        loading: 'Chargement',
        copied: 'Copié',
        failedToCopy: 'Échec de la copie',
        refresh: 'Actualiser',
        confirmationCode: 'Code de confirmation',
        passwordLength: 'Le mot de passe a plus de 8 caractères.',
        passwordSpecialChar: 'Le mot de passe a des caractères spéciaux.',
        passwordNumber: 'Le mot de passe contient un chiffre.',
        passwordCapital: 'Le mot de passe contient une lettre majuscule.',
        passwordLetter: 'Le mot de passe contient une lettre.',
        nothingWasFound: 'Rien n’a été trouvé',
        update: 'Mettre à jour',
        newVersionIsAvailable:
            'Une nouvelle version de l’application Web est disponible!',
        pleaseClickUpdate:
            'Veuillez cliquer sur le bouton "Mettre à jour" sur le côté droit pour mettre à jour l’application et nous sommes prêts à partir!',
        required: 'Obligatoire',
        passwordErrorMessage: 'Le mot de passe n’est pas assez fort',
        notValidEmail: 'Courriel non valide',
        assigned: 'Assigné',
        assignment: 'Affectation',
        done: 'Terminé',
        settings: 'Paramètres',
        accountSettings: 'Paramètres du compte',
        organisationSettings: 'Paramètres de l’organisation',
        exportCsv: 'Exporter en CSV',
        exportExcel: 'Exporter en Excel',
        exportPdf: 'Exporter en PDF',
        exportQrPdf: 'Exporter avec code QR',
        createNew: 'Créer un nouveau',
        fileTooBig: 'Le fichier est trop volumineux',
        emailTo: 'À',
        emailCc: 'Cc',
        advancedInformation: 'Informations avancées',
        supportChat: 'Chat de support',
        account: 'Compte',
        manual: 'Manuel',
        support: 'Soutien',
        about: 'A propos de',
        online: 'En ligne',
        offline: 'Hors ligne',
        disconnected: 'Déconnecté',
        notFilterable: 'Non filtrable',
        expandTreeNodes: 'Développer tous les nœuds',
        collapseTreeNodes: 'Replier tous les nœuds',
        applyFilters: 'Appliquer les filtres',
        close: 'Fermer',
        login: 'Connexion',
        installation: 'Installation',
        success: 'Succès'
    },
    tom: {
        openTomBtnTitle: 'Nouvelles images à examiner',
        loadMore: 'Charger plus',
        contentType: 'Type de contenu',
        reportType: 'Type de rapport',
        createdAt: 'Créé le',
        updatedAt: 'Mis à jour le',
        status: 'Statut',
        bedbug: 'Punaise de lit',
        ant: 'Fourmi',
        roach: 'Cafard',
        moth: 'Mite',
        cockroach: 'Cafard',
        fly: 'Insectes',
        other: 'Autre',
        mouse: 'Souris',
        rat: 'Rat',
        activated: 'Activé',
        activity: 'Activité',
        falseTrigger: 'Fausse alerte',
        reviseReport: 'Réviser le rapport',
        openTom: 'Ouvrir TOM',
        user_processed: 'Traité par l’utilisateur',
        not_processed: 'Non traité',
        ai_processed: 'Traité par l’IA',
        ai_and_user_processed: 'Traité par l’IA et l’utilisateur',
        tomMode: 'Mode TOM',
        period: 'Période',
        pileEmpty: 'La pile est vide.',
        allProcessed: 'Toutes les images ont été traitées.',
        deviceName: 'Nom du dispositif',
        companyName: 'Nom de la compagnie',
        dateTime: 'Date et heure',
        operationMode: 'Mode de fonctionnement',
        ok: 'OK',
        warning: 'Avertissement',
        critical: 'Critique',
        comments: 'Commentaires',
        aiProcessed: 'Cette image a été traitée automatiquement par l’IA',
        userProcessed: 'Cette image a été traitée par l’utilisateur',
        location: 'Emplacement',
        system: 'Système',
        noDevicePictures: 'Aucune image pour cet appareil',
        noPictures: 'Il n’y a pas encore d’images TOM',
        notUsingTom:
            'Vous n’utilisez pas encore notre nouveau produit « TOM » ?',
        discoverTom: 'Découvrez TOM',
        reportedBy: 'Signalé par',
        amount: 'Montant',
        makeReport: 'Créer un rapport',
        relevantPictures: 'Les images pertinentes',
        allPictures: 'Tous les images'
    },
    mobileAppScreen: {
        title: 'Nous optimisons actuellement notre application Web pour les appareils mobiles.',
        subtitle:
            'Pour une meilleure expérience utilisateur, veuillez télécharger notre application sur l’App Store ou Google Play Store.'
    },
    addressForm: {
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        company: 'Entreprise',
        streetAndNumber: 'Rue & Numéro',
        zip: 'Code postal',
        city: 'Ville',
        country: 'Pays',
        note: 'Note',
        companyNameRequireValidationMessage:
            "Le nom de l'entreprise est requis",
        companyNameMinLengthValidationMessage:
            "Le nom de l'entreprise est trop court",
        companyNameMaxLengthValidationMessage:
            "Le nom de l'entreprise est trop long",
        companyIsValidValidationMessage: "Nom d'entreprise invalide",
        nameRequireValidationMessage: 'Le prénom est requis',
        nameMinLengthValidationMessage: 'Le prénom est trop court',
        nameMaxLengthValidationMessage: 'Le prénom est trop long',
        nameIsValidValidationMessage: 'Prénom invalide',
        lastNameRequireValidationMessage: 'Le nom de famille est requis',
        lastNameMinLengthValidationMessage: 'Le nom de famille est trop court',
        lastNameMaxLengthValidationMessage: 'Le nom de famille est trop long',
        lastNameIsValidValidationMessage: 'Nom de famille invalide',
        addressRequireValidationMessage: 'Rue & Numéro sont requis',
        addressIsValidValidationMessage: 'Format de Rue & Numéro invalide',
        zipCodeRequireValidationMessage: 'Le code postal est requis',
        zipCodeIsValidValidationMessage: 'Code postal invalide',
        cityRequireValidationMessage: 'La ville est requise',
        cityIsValidValidationMessage: 'Nom de ville invalide',
        countryRequireValidationMessage: 'Le pays est requis',
        countryIsValidValidationMessage: 'Nom de pays invalide'
    },
    billing: {
        billing: 'Facturation',
        externalUsersCreationNotice:
            "Les nouveaux utilisateurs externes créés après le 01.01.2025 seront facturés 2,50 € HT par mois chacun. Vous pouvez trouver l'aperçu de vos abonnements mensuels dans le tableau de bord de facturation.",
        escalationLevelsCreationNotice:
            "Les nouvelles adresses e-mail utilisées pour les niveaux d'escalade attribués après le 01.01.2025 seront facturées 2,50 € HT par mois chacune. Vous pouvez trouver l'aperçu de vos abonnements mensuels dans le tableau de bord de facturation.",
        billingDashboard: 'Tableau de bord de facturation',
        lastHeartbeat: 'Dernier heartbeat',
        removedAt: 'Supprimé le',
        externalUsers: 'Utilisateurs externes',
        amount: 'Montant',
        apiDevices: 'API des appareils',
        monetisation: 'Monétisation',
        itCanUpToAMinute: "Cela peut prendre jusqu'à une minute",
        currentMonth: 'Mois en cours'
    }
}

export default fr

/*
([a-z]+)([:])
"$1"$2
*/
